var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { staticClass: "pa-0 ma-0 custom-container" },
    [
      _c(
        "v-row",
        {
          staticClass: "d-flex py-0 px-0",
          staticStyle: { "min-height": "80px" },
          attrs: { "no-gutters": "" },
        },
        [
          _c(
            "v-col",
            { staticClass: "d-flex align-end px-4", attrs: { cols: "12" } },
            [
              _c("span", {
                staticClass: "text-subtitle-4 text--text text--lighten-1",
                domProps: { textContent: _vm._s(_vm.$t("requests.client")) },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-autocomplete", {
                ref: "clientAutocomplete",
                staticClass: "custom-v-autocomplete",
                attrs: {
                  "data-cy": "client-autocomplete",
                  placeholder: _vm.$t("explore.select-client"),
                  items: _vm.groupedClients,
                  "item-value": "id",
                  "item-text": _vm.formatItemText,
                  "return-object": "",
                  labelDisplaySelection: true,
                  inputHeight: 45,
                  disabled: _vm.isDisabled,
                  dense: "",
                  flat: "",
                  solo: "",
                },
                on: { input: _vm.onClientSelected, change: _vm.scrollToStart },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function ({ item }) {
                      return [
                        _c("div", { staticClass: "d-flex flex-column mb-1" }, [
                          _c(
                            "span",
                            {
                              class: [
                                "text--base",
                                { "selected-item": _vm.isItemSelected(item) },
                                {
                                  "text-body-1-medium":
                                    _vm.isItemSelected(item),
                                },
                                {
                                  "text-body-1 text--text":
                                    !_vm.isItemSelected(item),
                                },
                              ],
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.formatItemName(item)) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          item.company?.name
                            ? _c(
                                "span",
                                {
                                  class: [
                                    "text--text",
                                    "text--lighten-1",
                                    {
                                      "selected-item": _vm.isItemSelected(item),
                                    },
                                    {
                                      "text-body-3-medium":
                                        _vm.isItemSelected(item),
                                    },
                                    {
                                      "text-body-3": !_vm.isItemSelected(item),
                                    },
                                  ],
                                },
                                [_vm._v(_vm._s(item.company.name))]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.selectedItem,
                  callback: function ($$v) {
                    _vm.selectedItem = $$v
                  },
                  expression: "selectedItem",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }